





























































































import { Component, Vue } from "vue-property-decorator";
import { IMember } from "../../models/Member.model";
import { updateProfile } from "@/graphql/members";
import FileUpload from "@/components/shared/FileUpload.vue";

@Component({ components: { FileUpload } })
export default class UserForm extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get member() {
    return this.$store.getters.getUser;
  }

  async updateProfile() {
    this.member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateProfile(this.member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
    } else alert("an error has occured!");
  }

  submit = false;
  disableSubmit() {
    this.submit = true;
  }

  enableSubmit() {
    this.submit = false;
  }

  uploaded(link: string) {
    this.member.link = link;
  }
}
